<template>

  <div class="full-width" ref="billDetailDom">

      <el-row :gutter="10" >
        <el-col :span="cols" class="info-parts" @click="clickGoDetailBtn" >

          <span style="color: #1a9aef">{{obj.commonref}}</span>
        </el-col>
        <el-col :span="cols" class="info-parts">

          <span>{{obj.name}}</span>
        </el-col>
        <el-col :span="cols" class="info-parts">

          <span>{{obj.addinfo3}}</span>
        </el-col>
        <el-col :span="cols" class="info-parts">

          <span>{{obj.inputdate}}</span>
        </el-col>

        <el-col :span="cols" class="info-parts">

          <span> {{obj.currinorder}} {{obj.totalsum}}</span>
      </el-col>
        <el-col :span="cols" class="info-parts"  v-if="myUtil.isNotEmpty(obj.orderno)">
          <span>{{obj.orderno}}</span>
        </el-col>

        <el-col :span="cols" class="info-parts">
          <span>{{obj.verify == -1 ? i18n.tkey("lang_certified") : i18n.tkey("lang_not_certified")}} </span>
<!--          <el-text type="primary" style="padding-left:8px; " tkey="查看">{{i18n.tkey("lang_jump_to_view")}}</el-text>-->
          <el-text type="primary" @click="clickGoDeleteBtn" style="padding-left:8px; " tkey="刪除">{{i18n.tkey("lang_delete")}}</el-text>
        </el-col>

      </el-row>
    </div>
</template>

<script setup>

import {inject, onMounted, ref} from "vue";
    import myUtil from "@/util/util";

    const props = defineProps(["obj"])
    const emits = defineEmits(["clickGoDetail","clickDelete"])

    const i18n = inject("i18n")
    const cols = ref(24)

    function clickGoDetailBtn() {
        emits("clickGoDetail", props.obj.id, props.obj.CompanyCode)
    }
    function clickGoDeleteBtn(){

      emits("clickDelete", props.obj.id)
    }

onMounted(() => {
  if (myUtil.isMobile()){
    cols.value = 12
  }else{
    cols.value = 4
  }

})
</script>

<style scoped>
    .record-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px #E4E7ED solid;
    }

    .record-box .info-part {
        display: flex;
        align-items: center;
        width: calc(100% - 50px);
    }

    .record-box .info-part .part-text {
        width: 33%;
        text-align: left;
    }

    .record-box .operation-part {
        width: 50px;
    }
    .full-width {
      width: 100%;
      padding: 10px;
    }

    .title-part {
      text-align: left;
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .info-parts {
      padding: 10px;
      text-align: left;
      font-size: 15px;
    }
</style>